import { OpDescr } from '../core/op-descr'
import { OpFile } from '../core/op-file'
import { OpDashboardControl } from './op-dashboard-control'


export class OpTileControl extends OpDashboardControl {
    //Properties
    public amount: any
    public icon: OpFile
    public amountVisible: boolean
    public texHeaderVisible: boolean
    public iconVisible: boolean
    public borderRadius: number[]
    public borderWidth: number
    public shadowHorizontalLenght: number
    public shadowVerticalLenght: number
    public shadowBlurRadius: number
    public shadowSpreadRadius: number
    //Properties end

    //NavigationProperties
    public textHeader: OpDescr
    //NavigationProperties end

    constructor(opObj: any) {
        super(opObj)
        if (opObj) {
            this.amount = opObj.Amount
            this.icon = opObj.Icon
            this.amountVisible = opObj.AmountVisible
            this.texHeaderVisible = opObj.TexHeaderVisible
            this.iconVisible = opObj.IconVisible
            this.borderRadius = opObj.BorderRadius
            this.borderWidth = opObj.BorderWidth
            this.shadowHorizontalLenght = opObj.ShadowHorizontalLenght
            this.shadowVerticalLenght = opObj.ShadowVerticalLenght
            this.shadowBlurRadius = opObj.ShadowBlurRadius
            this.shadowSpreadRadius = opObj.ShadowSpreadRadius

            this.textHeader = new OpDescr(opObj.TextHeader)
        }
    }
}